export const types = (state) => state.types
